/**
 * Modulo que encapsula los formateadores localizados de fechas humanizadas (en letras).
 */

import { humanizeFn as humanizeFnStandard } from '../humanizeFn';
import { parse } from './parse';

/**
 * Devuelve la fecha y/o hora humanizada respestando el timezone.
 *
 * @param {Object} state
 * @param {Date} value el objeto `date` a formatear
 * @returns {string}
 */
export function humanizeFn(state, value, dateFnsFormat) {
  return humanizeFnStandard(state, parse(state, value), dateFnsFormat);
}
